import { Flag, LocalOverrides } from 'services';
import flagData from '../featureFlags.json';

interface FlagResource {
  readonly active: boolean;
  readonly description: string;
  readonly jira: string;
}

interface FlagDataResource {
  readonly [key: string]: FlagResource;
}

interface FlagData {
  [key: string]: Flag;
}

/** Interface for feature flags and overrides */
class FeatureFlags {
  private _flags: FlagData = {};

  constructor(flags: FlagDataResource) {
    this.processFlags(flags);
  }

  /** Returns array of all flags with keys assigned to object */
  getAll() {
    return Object.keys(this._flags).map(
      (key: string): Flag => this._flags[key],
    );
  }

  /** Returns if given flag is active or not. */
  isActive(key: string) {
    const flag = this._flags[key];
    return flag ? flag.active : false;
  }

  /** Create and cache Flag instances from json data */
  processFlags(flags: FlagDataResource = {}) {
    this._flags = {} as FlagData;
    const keys = Object.keys(flags);

    if (keys.length === 0) {
      return;
    }

    const overrides = LocalOverrides.keys;

    for (let key of keys) {
      const flag = flags[key];
      const { active, description, jira } = flag;
      const override = overrides.has(key);

      this._flags[key] = new Flag(key, active, description, jira, override);
    }
  }
}

const FeatureFlagsInstance = new FeatureFlags(flagData);

export { FeatureFlagsInstance as FeatureFlags };
